import React, { FC } from 'react'
import Grid from '@sport1/react-elements/Grid'
import FontelloIcon from '@sport1/react-elements/FontelloIcon'
import Touchable from '@sport1/react-elements/Touchable'
import OnBoardingBodyFont from '../../Theme/Fonts/OnboardingBody'
import { MinifiedTouchableProps } from '../../elementsExports/Touchable'
import FeatureDiscoveryPopUpArrow, { FeatureDiscoveryPopUpArrowProps } from './Arrow'

export type FeatureDiscoveryPopUpProps = {
    /** the headline of the popup box */
    headline: string
    /** the text underneath the headline */
    text: string
    /** zIndex to be able to manage on which layer the box should be displayed */
    zIndex?: number
    /** the position of the arrow */
    arrowProps?: FeatureDiscoveryPopUpArrowProps
    /** all possible touchable props for the close icon */
    closeTouchableProps: MinifiedTouchableProps
}

const FeatureDiscoveryPopUp: FC<FeatureDiscoveryPopUpProps> = ({
    headline,
    text,
    zIndex,
    arrowProps,
    closeTouchableProps,
}) => (
    <Grid
        noExpand
        position="relative"
        padding={5}
        backgroundColor="ORANGE"
        borderRadius={2}
        marginY={3}
        zIndex={zIndex}
        elevation={4}
    >
        <Grid position="absolute" top={0} right={0}>
            <Touchable {...closeTouchableProps}>
                <FontelloIcon name="close-x" fontSize={12} padding={3} />
            </Touchable>
        </Grid>
        <OnBoardingBodyFont bold color="WHITE" numberOfLines={2}>
            {headline}
        </OnBoardingBodyFont>
        <OnBoardingBodyFont color="WHITE">{text}</OnBoardingBodyFont>
        {arrowProps ? <FeatureDiscoveryPopUpArrow {...arrowProps} /> : null}
    </Grid>
)

export default FeatureDiscoveryPopUp
